export default function Rights() {
  return (
    <section className="sales-layout__page">
      <h1>Rechte</h1>
      <p>Die Rechteverwaltung ist in Vorbereitung.</p>
    </section>
  );
}
